import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

const inputRootSelector = '.MuiOutlinedInput-root';
const hoverableInputRootSelector = `${inputRootSelector}:not(.Mui-error):not(.Mui-disabled):not(.Mui-focused)`;
export const getGroupStyles = ({ customStyles }) => ({
  position: 'relative',
  ...customStyles,
});

export const fieldRowStyles = {
  display: 'flex',
  alignItems: 'stretch',
  '> .MuiFormControl-root + .MuiFormControl-root': {
    marginLeft: '-1px',
  },

  '&:hover': {
    [`${hoverableInputRootSelector}, ${hoverableInputRootSelector} .input-adornment`]: {
      borderColor: ({ palette }) => palette.border.inputHover,
    },

    [`${hoverableInputRootSelector}[data-is-changed="true"], ${hoverableInputRootSelector}[data-is-changed="true"] .input-adornment`]:
      {
        borderColor: COLOR_PALETTE.ORANGE[6],
      },
  },
};

export const getFieldStyles = ({ widthPercent, isFirst, isLast, customStyles }) => ({
  position: 'relative',
  flex: `1 1 ${widthPercent ? `${widthPercent}%` : 0}`,
  minWidth: 0,

  '&:focus-within': {
    zIndex: 1,
  },

  [inputRootSelector]: {
    ...getConditionalObject(!isFirst, {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    }),

    ...getConditionalObject(!isLast, {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    }),
  },

  ...customStyles,
});
